import React, {Component} from "react";
import WinnerImage from "./winnerImage";
import WinnerContent from "./winnerContent";

class WinnerBox extends Component {
    render() {
        const {linkImage,prizeName,classList} = this.props;
        return (
            <>
            <div className={classList}>
               <WinnerImage linkImage={linkImage}/>
               <WinnerContent  prizeName={prizeName}/>
            </div>
            </>
        )
    }
}

export default WinnerBox;